import { InvalidOperationException } from "../Exceptions";
import { CancellationToken } from "../Promises/CancellationTokenSource";
import { IStreamReader } from "../Streams/IStreamReader";
import { IHashingAlgorithm } from "./Hash/IHashingAlgorithm";
/**
 * Umožňuje proudově hashovat pod ním ležící stream při jeho čtení
 */
export class HashingStreamReader implements IStreamReader {
    protected readonly _streamReader: IStreamReader;

    private readonly _hasher: IHashingAlgorithm;

    private _finished: boolean = false;
    private _hash?: BufferSource | null;

    /**
     * Celková velikost dat streamu
     */
    public get size(): number | null {
        return this._streamReader.size;
    }

    /**
     * Určuje zda už doběhlo hashování celého streamu a je možné vyčíst vypočítaný hash
     */
    public get finished(): boolean {
        return this._finished;
    }

    /**
     * Bytové pole s hashem celého streamu
     */
    public get hash(): BufferSource | null {
        if (!this.finished)
            throw new InvalidOperationException("Unable to compute final hash. Unfinished stream reading.");

        if (!this._hash) {
            this._hasher.finish();
            this._hash = this._hasher.result;
        }

        return this._hash;
    }

    constructor(streamReader: IStreamReader, hasher: IHashingAlgorithm) {
        this._hasher = hasher;
        this._streamReader = streamReader;
    }

    /**
     * Přečte blok dat ze streamu
     * @param start Počáteční pozice čtení (od kterého bytu se má začít číst) nebo undefined pro čtení od začátku
     * @param end Koncová pozice čtení (do kterého posledního bytu se má číst - včetně) nebo undefined pro čtení do konce streamu
     * @returns Přečtená binární data
     */
    public async read(start?: number, end?: number, cancellationToken?: CancellationToken): Promise<ArrayBuffer> {
        const block = await this._streamReader.read(start, end, cancellationToken);

        await this._hasher.update(block);
        this._finished = end == null ? block.byteLength === 0 : end >= this.size! - 1;

        return block;
    }
}
